import { groupByWeek, getDaysOfWeek } from 'utils/datetime';


angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor.editForm.weeks.service', [])
  .factory('weekService', [() => ({
    groupByWeek,
    getDaysOfWeek,
  })]);



// WEBPACK FOOTER //
// ./components/work-log-editor/edit-form/week.service.js